import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { first } from "rxjs/operators";
import { TaskService } from "../../core/service/task.service";
import { TaskRequestDTO } from "../../core/model/task-request-dto";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { CorrectionHistoryService } from "../../core/service/correction-history.service";
import { CorrectionHistory } from "../../core/model/correction-history";
import { Formulaire } from "src/app/parametrage/core/model/formulaire";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { AnnulerCorrection } from "../../core/model/annuler-correction";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { RetournerDossierModalComponent } from "src/app/formulaire/modal/retourner-dossier-modal/retourner-dossier-modal.component";
import { SuiviComponent } from "src/app/formulaire/modal/suivi/suivi.component";
import { TrouverEmployeeModalComponent } from "src/app/formulaire/modal/trouver-employee-modal/trouver-employee-modal.component";
import { DeplacerGroupDossier } from "src/app/core/services/business/model/deplacer-group-dossier";
import { LibererGroupDossier } from "src/app/core/services/business/model/liberer-group-dossier";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { FormAssignerGroupDossierComponent } from "src/app/formulaire/modal/form-assigner-group-dossier/form-assigner-group-dossier.component";

@Component({
  selector: "app-tache-en-cours",
  templateUrl: "./tache-en-cours.component.html",
  styleUrls: ["./tache-en-cours.component.scss"],
})
export class TacheEnCoursComponent implements OnInit {
  aRegularier: string = localStorage.getItem("aRegularier");
  criteria: string = "_";
  filter: string = "";
  username: String;
  myUsername: String;
  maxSize = 50;

  isLoadingResults = true;

  Error: String = null;

  dossiers: TaskRequestDTO[];

  page: number = 1;
  totalElements: number = 0;

  dossiersAcorriger: CorrectionHistory[];
  demandesDeCorrection: CorrectionHistory[];

  formulaireTask: Formulaire;
  formulaireUpdate: FormulaireDTO;

  annulerDemandeCorrection: AnnulerCorrection;

  formulaire: FormulaireDTO;

  listDossier: String[] = [];

  deplacerGroupDossiers: DeplacerGroupDossier = new DeplacerGroupDossier();
  libererGroupDossiers: LibererGroupDossier = new LibererGroupDossier();

  constructor(
    private _router: Router,
    private _keycloakService: KeycloakService,
    private modalService: NgbModal,
    private _taskService: TaskService,
    private _correctionHistoryService: CorrectionHistoryService,
    private _formulaireService: FormulaireService,
    private _requestService: RequestService
  ) {
    this.myUsername = _keycloakService.getUsername();
    this.username = this.myUsername;
  }

  ngOnInit() {
    this.findTask(
      this.aRegularier,
      this.criteria,
      this.filter,
      this.username,
      0,
      this.maxSize
    );
    this.mesDossiersACorriger(this.username);
    this.mesDemandesDeCorrection(this.username);
  }

  findTask(aregulariser, criteria, filter, username, page, size) {
    //this.listDossier = [];

    this.isLoadingResults = true;
    this._taskService
      .findTask("_", aregulariser, criteria, filter, username, page, size, "createTime", "desc")
      .subscribe(
        (data) => {
         /*this.dossiers = data.data.sort((a, b) =>
            a.task.createTime < b.task.createTime ? 1 : -1
          );*/
          this.dossiers = data.data;
          this.totalElements = data.total;
          this.Error = null;
          this.isLoadingResults = false;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );
  }

  loadPage(page: number): void {
    page = page - 1;
    this.findTask(
      this.aRegularier,
      this.criteria,
      this.filter,
      this.username,
      page,
      this.maxSize
    );
  }

  /*refresh():void
  {
    this.loadPage(this.page);
    this.mesDossiersACorriger(this.username);
    this.mesDemandesDeCorrection(this.username);
  }*/

  searchAndRefresh(): void {
    this.findTask(
      this.aRegularier,
      this.criteria,
      this.filter,
      this.username,
      0,
      this.maxSize
    );
    this.mesDossiersACorriger(this.username);
    this.mesDemandesDeCorrection(this.username);
  }

  normalARegulariser(): void {
    localStorage.setItem("aRegularier", this.aRegularier);
    this.findTask(
      this.aRegularier,
      this.criteria,
      this.filter,
      this.username,
      0,
      this.maxSize
    );
  }

  mesDossiersACorriger(username) {
    this._correctionHistoryService.mesDossiersACorriger(username).subscribe(
      (data) => {
        this.dossiersAcorriger = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  mesDemandesDeCorrection(username) {
    this._correctionHistoryService.mesDemandesDeCorrection(username).subscribe(
      (data) => {
        this.demandesDeCorrection = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  takeFormExecutionTask(requestId, taskId) {
    this._formulaireService.takeFormExecutionTask(taskId).subscribe(
      (data) => {
        this.formulaireTask = data;
        this._router.navigateByUrl(
          this.formulaireTask.lien + requestId + "/" + taskId
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  takeFormUpdateRequest(correctionId) {
    this._formulaireService.takeFormUpdateRequest(correctionId).subscribe(
      (data) => {
        this.formulaireUpdate = data;
        this._router.navigateByUrl(this.formulaireUpdate.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  retourner(requestId) {
    const modalRef = this.modalService.open(RetournerDossierModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
        this.searchAndRefresh();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  annulerCorrection(correctionId) {
    this.annulerDemandeCorrection = new AnnulerCorrection();
    this.annulerDemandeCorrection.correctionId = correctionId;
    this._correctionHistoryService
      .annuler(this.annulerDemandeCorrection)
      .subscribe(
        (data) => {
          this.searchAndRefresh();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  suivi(requestId) {
    const modalRef = this.modalService.open(SuiviComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {}
    );
  }

  recherche(): void {
    const modalRef = this.modalService.open(TrouverEmployeeModalComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.username = data;

        this.searchAndRefresh();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  cocher(value: any) {
    if (value.currentTarget.checked == true) {
      this.listDossier.push(value.currentTarget.id);
      console.log(this.listDossier);
    } else if (value.currentTarget.checked == false) {
      const index = this.listDossier.indexOf(value.currentTarget.id);
      if (index !== -1) {
        //si ça existe
        this.listDossier.splice(index, 1);
        console.log(this.listDossier);
      }
    }
  }

  cocherTout() {
    this.listDossier = [];
    for (let doss of this.dossiers) {
      this.listDossier.push("" + doss.task.id);
    }
    console.log(this.listDossier);
  }

  isChecked(taskid: string) {
    const index = this.listDossier.indexOf(taskid);
    if (index !== -1) {
      //si ça existe
      return true;
    }
  }

  libererGroupDossier(): void {
    this.libererGroupDossiers.taskIdList = this.listDossier;
    this._requestService
      .libererGroupDossier(this.libererGroupDossiers)
      .pipe(first())
      .subscribe(
        (data) => {
          this.listDossier = [];
          this.searchAndRefresh();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  assignerGroupDossier() {
    const modalRef = this.modalService.open(FormAssignerGroupDossierComponent, {
      centered: true,
    });
    modalRef.componentInstance.dossierList = this.listDossier;

    modalRef.result.then(
      (data) => {
        // on close
    this.listDossier = [];
        this.searchAndRefresh();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deplacerGroupDossierDansAregulariser(): void {
    this.deplacerGroupDossiers.taskIdList = this.listDossier;
    this._requestService
      .deplacerGroupDossierDansAregulariser(this.deplacerGroupDossiers)
      .pipe(first())
      .subscribe(
        (data) => {
          this.listDossier = [];
          this.searchAndRefresh();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  deplacerGroupDossierDansNormal(): void {
    this.deplacerGroupDossiers.taskIdList = this.listDossier;
    this._requestService
      .deplacerGroupDossierDansNormal(this.deplacerGroupDossiers)
      .pipe(first())
      .subscribe(
        (data) => {
          this.listDossier = [];
          this.searchAndRefresh();
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
